import { OrmModel, StringField, BooleanField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { AutomationStepType } from '@/data/models/domain/automations/types'

@OrmModel(modelNames.AUTOMATION_LOG_STEP)
export default class AutomationLogStep<T extends AutomationStepType = AutomationStepType> extends BaseModel {
  @StringField()
  public type: T

  @StringField()
  public title: string

  @BooleanField()
  public isDeleted: boolean
}
